import {
  TypedForm,
  FormErrors as FormErrorsBase,
  ObjectSchema,
  string,
  object,
} from 'libs/form';

export const LENGTH_LEI = 20;
export const LENGTH_GIIN = 19;

export interface IdentificationNumbersFormType {
  LEI?: string | null;
  GIIN?: string | null;
}

export const getSchema = (): ObjectSchema<IdentificationNumbersFormType> =>
  object({
    LEI: string().length(LENGTH_LEI).nullable(),
    GIIN: string().length(LENGTH_GIIN).nullable(),
  });

export const { Field, Form, useFormContext, Submit } =
  TypedForm<IdentificationNumbersFormType>();

export type FormErrors = FormErrorsBase<IdentificationNumbersFormType>;
